module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// D:/13公司官网/LinkGW/node_modules/_axios@0.21.0@axios/index.js
// module id = C6wW
// module chunks = 0